import React, {useState, useEffect, useRef, useCallback} from 'react';
// import validator from 'validator';
import { useQuoteState } from "./quoteState";
import { Modal } from "../../modal/Modal";

// import { FormFieldDefinitions } from '../formDefinitions';
// import { FormFieldDefinitions, specialRequestsValues } from '../formDefinitions';
import { FormField } from '../formFields';

import { formDataFromStorage, WebhookPayload, validateFields } from '../utils';
// import { MECHANIC_WEBHOOK_URL, GOOGLE_LOGGER_URL, ZAPIER_WEBHOOK_URL } from '../constants';


import useSubmitQuoteForm from '../hooks/useSubmitQuoteForm';
// import useFieldValidation from '../hooks/useFieldValidation';

// import useCalculateSurfacingCost from '../hooks/useCalculateSurfacing';


export const QuoteForm = () => {
  const formRef = useRef(null);
  const sectionRefs = useRef({});
  
  // const { items, totalPrice } = useQuoteState()
  // const [expirationDate, setExpirationDate] = useState(calculateExpirationDate(new Date()));
  const { items, totalPrice, expirationDate } = useQuoteState()
  

  const [formData, setFormData] = useState(formDataFromStorage())
  const [formFields, setFormFields] = useState(FormFieldDefinitions)
  const [formErrors, setFormErrors] = useState({})
  const [taxFile, setTaxFile] = useState({})

  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  // const {totalInstallationCost, totalInstallationPrice, allItemsHaveInstall} = useInstallationCost(items, selectedState);
  // const {pip_prc, turf_prc} = useCalculateSurfacingCost(items, formData['critical_fall_height'] || 0, formData['surfacing_square_footage'] || 0);
  
  const { validateField } = validateFields(formData, taxFile);

  // const { submitForm, formErrors: submitFormErrors, showModal: submitFormShowModal } = useSubmitQuoteForm(items, formData, taxFile, totalPrice, expirationDate);
  const { submitForm, formErrors: submitFormErrors, isSubmitting, showModal, setShowModal } = useSubmitQuoteForm(items, formData, taxFile, totalPrice, expirationDate);

  

  const firstSection = formFields.length > 0 ? formFields[0].section : null;
  // Open the first section on load
  const [openSections, setOpenSections] = useState(firstSection ? { [firstSection]: true } : {});
  const [sectionsWithErrors, setSectionsWithErrors] = useState({});

  // const [collections, setCollections] = useState([]);
  

  
  const menuHeight = document.querySelector('.shopify-section__header').offsetHeight;



  // useEffect(() => {
  //   setShowModal(submitFormShowModal);
  // }, [submitFormShowModal]);

  const handleSubmit = () => {
    submitForm(formFields);
  };

  
  
  const groupedFields = formFields.filter(field => field.section).reduce((acc, field) => {
    const section = field.section;
    acc[section] = acc[section] || [];
    acc[section].push(field);
    return acc;
  }, {});

  
  const sectionKeys = Object.keys(groupedFields);


  const generateSectionSummary = (section) => {
    const fields = groupedFields[section].filter(field => field.summary);
    if (fields.length === 0) return '';
  
    return fields.map((field, index) => {
      let value = formData[field.name] || '';
      const nextFieldHasValue = fields[index + 1] && formData[fields[index + 1].name];
      const className = field.summary_style || 'summary-value';
      const hasComma = field.summary_comma || false;
      const isCheckbox = field.type === 'checkbox' || field.type === 'radio';
      const isLineBreak = field.summary_line_break || false;
      
      if (field.name === 'select_buying_for' && value === 'Other (Please Specify)') {
        value = formData['specific_buying_for'] || '';
      }

      // if (field.name === 'quote_installation' && value !== null) {
      //   field.label = 'Quote Installation';
      // }
  
      return (
        <>
        {/* {field.summary_line_break ? <br /> : null} */}
          <span key={`summary-${field.name}-${index}`} className={`summary-value ${className} ${nextFieldHasValue && hasComma ? 'summary-comma' : ''} ${isLineBreak ? 'summary-line-break' : ''}`}>
            {isCheckbox && value ? `${field.label}: ${value}` : value}
          </span>
        </>
      );
    });
  };

  const toggleSection = (section, shouldScroll = false) => {
    const currentSectionIndex = sectionKeys.indexOf(section);
    const previousSectionIndex = currentSectionIndex > 0 ? sectionKeys[currentSectionIndex - 1] : null;
    if (currentSectionIndex === 0 || previousSectionIndex === null || validateSection(previousSectionIndex)) {
      setOpenSections(prev => ({ ...prev, [section]: !prev[section] }));
      if (shouldScroll && sectionRefs.current[section]) {
        window.scrollTo({
          top: sectionRefs.current[section].offsetTop - menuHeight,
          behavior: "smooth"
        });
      }
    }
  };

  const openSection = (currentSection, shouldScroll = false) => {
    if (validateSection(currentSection)) {
      setOpenSections(prev => ({ ...prev, [currentSection]: true }));
      const currentSectionIndex = sectionKeys.indexOf(currentSection);
      const nextSection = sectionKeys[currentSectionIndex + 1];
      if (nextSection) {
        setOpenSections(prev => ({ ...prev, [nextSection]: true }));
        if (shouldScroll && sectionRefs.current[nextSection]) {
          window.scrollTo({
            top: sectionRefs.current[nextSection].offsetTop - menuHeight,
            behavior: "smooth"
          });
        }
      }
    }
  };



  /** Recompute field visibility/options only when install/surfacing/cart-derived rules change — not on every keystroke. */
  const toggleOptionalFields = useCallback(() => {
    const hasEngineeredDrawings = items.some(item => 
      item.options.some((option) =>
        ['Sealed Digital Engineered Drawings', 'Sealed Physical Engineered Drawings', 'Sealed Engineered Drawings'].includes(option.value)
      )
    );

    const sameProductTypeCount = items.reduce((acc, item) => {
      acc[item.productType] = (acc[item.productType] || 0) + 1;
      return acc;
    }, {});
    const showSpecialRequest = sameProductTypeCount['Large Play Systems'] > 1;
    

    const updatedSpecialRequestsValues = showSpecialRequest 
      ? [...specialRequestsValues, "I added lots of playgrounds to my quote, but I am only looking for one"]
      : specialRequestsValues;

    const hasInstallRequest = formData['quote_installation'] === "Yes";
    const hasSurfacingRequest = formData['surfacing_request'] === "Yes";
    const onlyBordersOrGaGa = items.every(item => 
      ['Playground Borders', 'GaGa Ball Pits'].includes(item.productType)
    );

    const validTypes = ["Pour in Place Surfacing", "Engineered Wood Fiber", "Artificial Turf"];
    const hasValidSurfacingType = validTypes.includes(formData['surfacing_type']);

    const hasTightDeadline = formData['accommodations']?.includes("I have a very tight and/or strict deadline");


    const fieldUpdates = {
      "tax_certificate": {
        type: formData['tax_exempt'] === "Yes" ? "file" : "hidden",
        required: formData['tax_exempt'] === "Yes",
      },
      "specific_buying_for": {
        type: formData['select_buying_for'] === "Other (Please Specify)" ? "text" : "hidden",
        required: formData['select_buying_for'] === "Other (Please Specify)" ? true : false
      },
      
      "quote_installation": {
        type: onlyBordersOrGaGa ? "hidden" : "radio",
      },
      "surfacing_type": {
        type: hasSurfacingRequest ? "radio" : "hidden",
      },
      "critical_fall_height": {
        type: hasSurfacingRequest ? "select_value" : "hidden",
      },
      "current_surface": {
        type: hasSurfacingRequest ? "select" : "hidden",
      },
      "surfacing_square_footage" : {
        type: hasSurfacingRequest && hasValidSurfacingType ? "number" : "hidden",
      },

      "accommodations": {
        type: hasInstallRequest || hasSurfacingRequest ? "checkbox" : "hidden",
      },
      
      "project_deadline": {
        // type: hasTightDeadline && hasInstallRequest ? "text" : "hidden",
        type: hasTightDeadline ? "text" : "hidden",
      },

      "site_dimensions": {
        type: hasInstallRequest || hasSurfacingRequest ? "length_width" : "hidden",
      },

      "building_code": {
        visibility: hasEngineeredDrawings ? "visible" : "hidden",
        type: hasEngineeredDrawings ? "select" : "hidden",
        required: hasEngineeredDrawings
      },
      "specific_building_code": {
        type: hasEngineeredDrawings && formData['building_code'] === "Other or I don't know..." ? "text" : "hidden",
        required: false
      },
      "special_requests": {
        options: updatedSpecialRequestsValues,
        type: onlyBordersOrGaGa ? "hidden" : "checkbox"
      },
      "budget_select": {
        type: onlyBordersOrGaGa ? "hidden" : "radio",
      },
      "timeframe_select": {
        type: onlyBordersOrGaGa ? "hidden" : "radio",
      },
      
      "looking_for": {
        type: onlyBordersOrGaGa ? "hidden" : "radio",
      },
      "residential_commercial": {
        type: "hidden",
        value: formData['select_buying_for'] === "Private Home" ? "Residential" : "Commercial"
      },
    };
  
    setFormFields(prev => prev.map(field => ({
      ...field,
      ...fieldUpdates[field.name]
    })));
  }, [
    items,
    formData.tax_exempt,
    formData.select_buying_for,
    formData.quote_installation,
    formData.surfacing_request,
    formData.surfacing_type,
    formData.accommodations,
    formData.building_code,
  ]);
  
  useEffect(() => {
    const handleStorageChange = () => setFormData(formDataFromStorage());
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  
  useEffect(() => {
    localStorage.setItem("quoteFormData", JSON.stringify(formData));
    window.dispatchEvent(new CustomEvent('formDataUpdated'));
  }, [formData]);

  useEffect(() => {
    toggleOptionalFields();
  }, [toggleOptionalFields]);


  useEffect(() => {
    const initialData = formDataFromStorage();
    setFormData(initialData);
    const isFormDataEmpty = Object.values(initialData).every(x => x === null || x === '');
  
    // Automatically open the first section if form data is empty
    if (isFormDataEmpty && formFields.length > 0) {
      const firstSection = formFields[0].section;
      setOpenSections({ [firstSection]: true });
    }

    localStorage.setItem("quoteFormData", JSON.stringify(initialData));

  }, []);


  
  const handleChange = e => {
    e.preventDefault;
    const { name, value, type, checked, files } = e.target;
    // console.log('e', e);
    
    setFormErrors(prevData => ({
      ...prevData,
      [name]: ""
    }));
    
    if (name === 'terms_of_service') {
      setIsTermsAccepted(checked);
      // Update form data to track terms acceptance 1/9/26
      setFormData(prevData => ({
        ...prevData,
        [name]: checked ? value : ''
      }));
      return;
    }


    if (name === 'site_length' || name === 'site_width') {
      setFormData(prevData => ({
        ...prevData,
        [name]: value,
        site_dimensions: `${name === 'site_length' ? value : prevData['site_length'] || ''} x ${name === 'site_width' ? value : prevData['site_width'] || ''}`
      }));
    } else if (type === 'checkbox' && (name === 'special_requests' || name === 'accommodations')) {
      setFormData(prevData => {
        const currentValues = Array.isArray(prevData[name]) ? prevData[name] : [];
        const updatedValues = checked 
            ? [...new Set([...currentValues, value])] 
            : currentValues.filter(item => item !== value);
        return {
            ...prevData,
            [name]: updatedValues
        };
      });
    } else {
      setFormData(prevData => ({
        ...prevData,
        [name]: value,
        ...(name === 'select_buying_for' && {
          residential_commercial: value === "Private Home" ? "Residential" : "Commercial"
        })
      }));
    }

  };

  const handleFileSelect = useCallback((file) => {
    if (!file) {
      setTaxFile({});
      setFormErrors(prev => ({ ...prev, tax_certificate: "" }));
      return;
    }
    const isPDF = file.type === "application/pdf" || file.name.toLowerCase().endsWith('.pdf');
    if (!isPDF) {
      setFormErrors(prev => ({ ...prev, tax_certificate: "Please upload PDF files only." }));
      setTaxFile({});
      return;
    }
    setTaxFile(file);
    setFormErrors(prev => ({ ...prev, tax_certificate: "" }));
  }, []);

  const countSectionErrors = (section) => {
    const sectionFields = groupedFields[section].map(field => field.name);
    const errorCount = sectionFields.reduce((count, fieldName) => {
      return count + (formErrors[fieldName] ? 1 : 0);
    }, 0);
    return errorCount;
  };


  const validateSection = (section) => {
    const fields = groupedFields[section];
    if (!fields) {
      console.error(`No fields found for section: ${section}`);
      return false;
    }

    let isValid = true;
    const newErrors = {};

    fields.forEach(field => {
      const error = validateField(field);
      if (error) {
        isValid = false;
        newErrors[field.name] = error;
      }
    });
  
    setFormErrors(prevErrors => ({
      ...prevErrors,
      ...newErrors
    }));

    setSectionsWithErrors(prev => ({
      ...prev,
      [section]: !isValid
    }));
  
    return isValid;
  };


  const isFormValid = () => {
    if (!isTermsAccepted) {
      return false;
    }

    // Validate all visible fields
    const visibleFields = formFields.filter(field => field.required === true && field.type !== 'hidden');
    let hasErrors = false;

    visibleFields.forEach(field => {
      const error = validateField(field);
      if (error) {
        hasErrors = true;
      }
    });

    // Check if there are any existing errors in formErrors
    const hasExistingErrors = Object.values(formErrors).some(error => error && error.trim() !== '');

    return !hasErrors && !hasExistingErrors;
  };





  return (
    <>
      {(items.length > 0) && (
        
        <div ref={formRef} className="quote-form-wrapper">
          

            {sectionKeys.map((section, index) => (
              <div key={section} className={`accordion-form accordion-form--${section}`} ref={el => sectionRefs.current[section] = el}>
                <button onClick={() => toggleSection(section, true)} className="card__collapsible-button accordion-toggle" aria-expanded={`${openSections[section] ? "true" : "false"}`}>
                    <span className="card__title heading h3">{section}</span>
                    {/* {(() => {
                      const errorCount = countSectionErrors(section);
                      return errorCount > 0 && <span className="card__error-count error-bubble">{errorCount}</span>;
                    })()} */}
                    {sectionsWithErrors[section] && <span className="card__error-count error-bubble">!</span>}
                    {!sectionsWithErrors[section] && <span className="card__summary">{generateSectionSummary(section)}</span>}
                    <span className="plus-button plus-button--large"></span>
                </button>

                <div id={`section-content-${section}`} className={`card__collapsible ${openSections[section] ? "expanded" : ""}`} style={{ height: openSections[section] ? "auto" : "0" }}>
                  <div className="grid-container card__collapsible-content">
                    {groupedFields[section].map((field) => (
                      <FormField key={`${section}-${field.name}`} field={field} formData={formData} formErrors={formErrors} handleChange={handleChange} onFileSelect={field.type === 'file' ? handleFileSelect : undefined} />
                    ))}
                  </div>

                  <div className="button-nav-container">
                    {(index > 0 && index < sectionKeys.length - 1) && (
                      // <button className="button button--small button--outline" onClick={() => toggleSection(sectionKeys[index - 1], true)}>Previous</button>
                      <button className="button button--small button--outline" onClick={() => openSection(sectionKeys[index - 1], true)}>Previous</button>
                    )}
                    {index < sectionKeys.length - 1 && (
                      // <button className="button button--small button--outline" onClick={() => toggleSection(sectionKeys[index + 1], true)}>Next</button>
                      <button className="button button--small button--outline" onClick={() => openSection(sectionKeys[index], true)}>Next</button>
                    )}
                  </div>
                </div>

              </div>
            ))}

            
            <div className="button-container">
              <div className="form-group form__input-wrapper wrapper-terms_of_service">
                <div className="radio-buttons">
                  <label className="control-label terms-label" htmlFor="terms_of_service">
                    By checking the box below and submitting your no-obligation quote, you agree to our&nbsp;<a href="/policies/terms-of-service" target="_blank">terms of use</a>.
                    <span className="required-asterisk"> *</span>
                  </label>
                    <input 
                      type="checkbox" name="terms_of_service" id="terms_of_service" value="I accept the terms of use" onChange={handleChange} 
                    />
                    <label className="terms-inner-label" htmlFor="terms_of_service">I accept the terms of use</label>
                </div>
                <div className="form-field-error">{formErrors['terms_of_service']}</div>
              </div>

              {/* <button id="quote-btn" className="button button--primary" onClick={handleSubmit}>Submit Quote</button> */}
              <button id="quote-btn" className="button button--primary" 
                // disabled={!isTermsAccepted || isSubmitting} 
                disabled={!isFormValid() || isSubmitting} 
                onClick={handleSubmit}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Quote'}
              </button>
              <a href="#" className="convert_to_cart_button button link link--underline link--underline--offset">Convert to Cart</a>
            </div>


            <div className="link-container">
              <p className="turn-around-time">Current quote turnaround time: <strong>1 business day</strong></p>
            </div>


            {['joel+test123@willygoat.com'].includes(formData['email']) && (
              <div>
                <h2>Webhook Payload</h2>
                {/* <pre>{JSON.stringify({
                  selectedState,
                  totalInstallationCost, 
                  totalInstallationPrice,
                  totalMargin, 
                  allItemsHaveInstall,
                  pip_prc,
                  // pip_cost, pip_mats_cost, pip_lab_cost, pip_mats_price, pip_lab_price
                }, undefined, 2)}</pre> */}
                {/* <pre>{totalInstallationCost}</pre> */}
                
                <pre>{JSON.stringify(WebhookPayload({ items, formData, taxFile, expirationDate, converted_total: null }), undefined, 2)}</pre>

                {/* <pre>
                  {JSON.stringify({pip_prc, turf_prc,}, undefined, 2)}
                </pre> */}
                {/* <pre>{JSON.stringify(enhancedConversionItems(items))}</pre> */}
              </div>
            )}
            
          
        </div>
        
      )}
      
      {/* <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
        <p className="heading h2" style={{lineHeight: '1.2', textAlign: 'center'}}>Thank you so much for requesting a quote from us!</p>
        <p className="heading h4" style={{marginBottom: '30px', textAlign: 'center'}}>We'll be in touch within 1 business days with next steps.</p>
        <div className="image-container" style={{textAlign: 'center'}}>
          <img src="https://cdn.shopify.com/s/files/1/0100/6072/6369/files/children-climbing.jpg?v=1718122800" alt="Children Climbing on Net Climber" style={{width: '70%'}} />
        </div>
        <p style={{marginBottom: '30px', textAlign: 'center'}}>Thanks for choosing WillyGoat!</p>

        <div className="quote-modal-buttons">
          <a className="button button--primary" href="/">Continue Shopping</a>
          <a className="button button--primary" href="/pages/thank-you-for-submitting-your-quote-v2">Close</a>
        </div>
      </Modal> */}

      <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
        <p className="heading h2" style={{lineHeight: '1.2', textAlign: 'center'}}>There was an error submitting. Please refresh and try again!</p>
      </Modal>
    </>
  )
}





